import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Launch-interest baseline so the badge reads credibly from day one.
const BASELINE = 1284;

export function useWaitlistCount() {
  const [count, setCount] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/waitlist/stats`);
      setCount(BASELINE + (res.data?.total || 0));
    } catch (e) {
      // keep last known value on failure
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 20000);
    return () => clearInterval(id);
  }, [refresh]);

  return { count, refresh };
}
